import { NetworkStatus } from 'components/network-status'
import { useEventListener } from 'hooks/use-event-listener'
import { createContext, ReactNode, useContext, useState } from 'react'
import { isDbConnectedPage } from 'utils/is-db-connected-page'

type Offline = boolean

const initialState: Offline = false

const OfflineContext = createContext(initialState)

export const OfflineProvider = ({ children }: { children: ReactNode }) => {
  const [isOffline, setIsOffline] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')

  useEventListener({
    eventType: 'online',
    listener: () => {
      // back online from offline
      if (isOffline) {
        if (isDbConnectedPage()) {
          setToastMessage("You're back online. Reconnecting...")
          setShowToast(true)

          setTimeout(() => {
            window.location.reload()
          }, 1500)
        } else {
          setToastMessage("You're back online.")
          setShowToast(true)
        }
      }

      setIsOffline(false)
    },
    wait: 0,
  })

  useEventListener({
    eventType: 'offline',
    listener: () => {
      setIsOffline(true)
      setToastMessage('You are offline.')
      setShowToast(true)
    },
    wait: 0,
  })

  const handleCloseToast = () => {
    setShowToast(false)
  }

  return (
    <OfflineContext.Provider value={isOffline}>
      {children}
      <NetworkStatus isOffline={isOffline} message={toastMessage} visible={showToast} onClose={handleCloseToast} />
    </OfflineContext.Provider>
  )
}

export const useOffline = () => useContext(OfflineContext)
